import {
    Component,
    OnInit,
    ChangeDetectionStrategy, Input, ViewChild, ElementRef,
} from '@angular/core';
import {StorageService} from '../../services/storage.service';

@Component({
    selector: 'app-alerts-components',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertsComponent implements OnInit {
    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    @Input() type = 'primary';
    @Input() id;
    @Input() icon;
    @Input() title;
    @Input() message;
    @Input() btnLink = null;
    @Input() btnTitle = null;
    @Input() btnCallback = null;
    @Input() callbackParent = null;
    @Input() disableClose = false;
    @Input() fontSize = null;

    constructor(private readonly storageService: StorageService) {
    }

    ngOnInit() {
        if (this.storageService.getItem(this.id) === 'hide') {
            this.wrapper.nativeElement.classList.add('hidden');
        }
    }

    hideAlert() {
        this.storageService.setItem(this.id, 'hide');

        this.wrapper.nativeElement.classList.add('animated');
        this.wrapper.nativeElement.classList.add('fadeOut');

        const _this = this;
        setTimeout(function () {
            _this.wrapper.nativeElement.classList.add('hidden');
        }, 1000);
    }

}
